import { render, staticRenderFns } from "./P404.vue?vue&type=template&id=15e96158&scoped=true&"
import script from "./P404.vue?vue&type=script&lang=js&"
export * from "./P404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e96158",
  null
  
)

export default component.exports